/* eslint-disable no-param-reassign */
import produce from 'immer';
var secondaryAnalysisFilesSublibraryIdsUpdated = produce(function (draft, action) {
  var _action$payload = action.payload,
    secondaryAnalysisId = _action$payload.secondaryAnalysisId,
    sublibraryPayload = _action$payload.sublibraryPayload;
  sublibraryPayload.forEach(function (_ref) {
    var sublibraryId = _ref.sublibraryId,
      fileIds = _ref.fileIds;
    fileIds.forEach(function (fileId) {
      if (draft[secondaryAnalysisId].files.data[fileId]) {
        draft[secondaryAnalysisId].files.data[fileId].sublibraryId = sublibraryId;
      }
    });
  });
});
export default secondaryAnalysisFilesSublibraryIdsUpdated;